import LocalizedStrings from 'localized-strings';

import { PaymentCardType } from 'types/creditCard';

const locales = new LocalizedStrings({
  en: {
    badge: 'Instant',
    deliveryPeriod: '2 to 3 weeks',
    description:
      'All our cards are Mastercard Business compatible with Apple Pay and Google Pay.',
    footer: {
      next: 'Next',
    },
    options: {
      [PaymentCardType.PHYSICAL]: {
        description: 'Perfect for everyday purchases and cash withdrawals.',
        title: 'Physical card',
      },
      [PaymentCardType.VIRTUAL]: {
        description:
          'Perfect for managing your subscriptions or for online payments, this card works like a physical card but on digital platforms.',
        title: 'Virtual card',
      },
      [PaymentCardType.TEMPORARY_VIRTUAL]: {
        description:
          'Ideal for one-time expenses. It expires on the defined date.',
        title: 'Virtual temporary card',
      },
    },
    prices: {
      alreadyActivated: 'Card already activated',
      free: 'Free',
      physicalCardCosts: '€{cardPrice} for shipping + €{monthlyFee} / month',
      virtualCardCost: '€{cardPrice} / month',
    },
    title: 'Choose a card type',
  },
  fr: {
    badge: 'Instantanée',
    deliveryPeriod: '2 à 3 semaines',
    description:
      'Toutes nos cartes sont des Mastercard Business compatibles avec Apple Pay et Google Pay.',
    footer: {
      next: 'Suivant',
    },
    options: {
      [PaymentCardType.PHYSICAL]: {
        description:
          'Idéale pour les achats du quotidien et les retraits d’espèces.',
        title: 'Carte physique',
      },
      [PaymentCardType.VIRTUAL]: {
        description:
          'Idéale pour gérer vos abonnements ou pour des paiements en ligne, cette carte fonctionne comme une carte physique mais sur des supports digitaux.',
        title: 'Carte virtuelle',
      },
      [PaymentCardType.TEMPORARY_VIRTUAL]: {
        description:
          'Idéale pour les dépenses ponctuelles. Elle expire à la date définie.',
        title: 'Carte virtuelle éphémère',
      },
    },
    prices: {
      alreadyActivated: 'Carte déjà activée',
      free: 'Gratuit',
      physicalCardCosts:
        '{cardPrice}\xa0€\xa0HT d’envoi + {monthlyFee}\xa0€\xa0HT / mois',
      virtualCardCost: '{cardPrice}\xa0€\xa0HT / mois',
    },
    title: 'Choisissez un type de carte',
  },
} as const);

export default locales;
